import { mapMutations } from "vuex"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    prizeList: {
      type: Object|Array,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      bindDialogVisible: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    hasPrize() {
      return Array.isArray(this.prizeList) ? (this.prizeList.length > 0) : (Object.keys(this.prizeList).length > 0)
    },
  },
  watch: {
    visible: async function (val) {
      this.dialogVisible = val
    }
  },
  methods: {
    ...mapMutations(['setBindDialog']),
    close() {
      this.$emit('update:visible', false)
    },
    handleClaim() {
      if (this.hasPrize) {
        this.bindDialogVisible = true
      } else {
        this.close()
      }
    },
    getImg(name) {
      return require('@/assets/img/common/gift/' + name)
    },
    handleBindSuccess() {
      this.$emit('success')
    },
  }
}